import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { MatchingActions } from './matching.actions';
import {
  selectMatches,
  selectShownMatches,
  selectActiveMatches,
  selectConnectedMatches,
  selectHistoryMatches,
  selectTotalCount,
  selectActionableCount,
  selectMatchesLoading,
  selectMatchingError,
} from './matching.selectors';

/**
 * Facade service for matching state management
 * Provides clean API for components to interact with matching NgRx store
 */
@Injectable({
  providedIn: 'root'
})
export class MatchingFacade {
  private readonly store = inject(Store);

  // Observables
  readonly matches$ = this.store.select(selectMatches);
  readonly shownMatches$ = this.store.select(selectShownMatches);
  readonly activeMatches$ = this.store.select(selectActiveMatches);
  readonly connectedMatches$ = this.store.select(selectConnectedMatches);
  readonly historyMatches$ = this.store.select(selectHistoryMatches);
  readonly totalCount$ = this.store.select(selectTotalCount);
  readonly actionableCount$ = this.store.select(selectActionableCount);
  readonly loading$ = this.store.select(selectMatchesLoading);
  readonly error$ = this.store.select(selectMatchingError);

  // Actions
  loadMatches(): void {
    this.store.dispatch(MatchingActions.loadMatches());
  }

  respondToMatch(proposalId: string, action: 'select' | 'accept' | 'decline'): void {
    this.store.dispatch(MatchingActions.respondToMatch({ proposalId, action }));
  }

  cancelMatch(proposalId: string): void {
    this.store.dispatch(MatchingActions.cancelMatch({ proposalId }));
  }

  clearError(): void {
    this.store.dispatch(MatchingActions.clearError());
  }
}
